import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import {
  formatEntityLensCode,
  parseLensNames,
} from 'utils/entityLensBadge';

type LensValue = string | string[] | null | undefined;

const MAX_VISIBLE_LENSES = 3;

interface LensBadgeListProps {
  value?: LensValue;
}

const LensBadgeList: React.FC<LensBadgeListProps> = ({ value }) => {
  const lenses = parseLensNames(value);
  const visibleLenses = lenses.slice(0, MAX_VISIBLE_LENSES);
  const hiddenLenses = lenses.slice(MAX_VISIBLE_LENSES);

  if (lenses.length === 0) {
    return <div className='screening-results-row-default-cell-text'>-</div>;
  }

  return (
    <div className='lens-badge-container'>
      {visibleLenses.map((lens, index) => (
        <Tooltip
          key={`${lens}-${index}`}
          title={lens}
          placement='top'
          arrow
        >
          <span className='screening-badge lens-chip chip-blue'>
            {formatEntityLensCode(lens)}
          </span>
        </Tooltip>
      ))}
      {hiddenLenses.length > 0 && (
        <Tooltip
          title={
            <div className='lens-overflow-tooltip'>
              {hiddenLenses.map((lens, index) => (
                <div key={`${lens}-${index}`}>{lens}</div>
              ))}
            </div>
          }
          placement='top'
          arrow
        >
          <span
            className='screening-badge lens-chip lens-overflow-chip chip-blue'
            tabIndex={0}
            aria-label={`${hiddenLenses.length} more lenses: ${hiddenLenses.join(
              ', ',
            )}`}
          >
            +{hiddenLenses.length}
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export default LensBadgeList;
